import NaptimeResource from './NaptimeResource';

class SkillSets extends NaptimeResource {
  static RESOURCE_NAME = 'skillSets.v1';
}

export default SkillSets;

export type LearnerSkillSetProficiency = {
  skillId: string;
  targetProficiency: number;
};

export type SkillSet = {
  academyIds?: string[];
  description: string;
  functionId: string;
  id: string;
  lure: string;
  occupationId: string;
  targetProficiencies?: LearnerSkillSetProficiency[];
  targetSkillProfileName: string;
  targetSkillProfileType: string;
};
